import React from 'react';
import WhatsAppCTA from './WhatsAppCTA';

interface SectionProofProps {
  title: string;
  intro: string;
  stat: { number: string; label: string };
  paragraphs: string[];
  highlight: string;
  cta: string;
  ctaMessage: string;
}

const SectionProof: React.FC<SectionProofProps> = ({ title, intro, stat, paragraphs, highlight, cta, ctaMessage }) => (
  <section className="lp-section lp-section--proof" aria-labelledby="proof-title">
    <div className="lp-container">
      <h2 id="proof-title">{title}</h2>
      <p className="lp-intro">{intro}</p>
      <div className="lp-proof-box">
        <div className="lp-proof-stat">
          <span className="lp-proof-stat__number">{stat.number}</span>
          <span className="lp-proof-stat__label">{stat.label}</span>
        </div>
        {paragraphs.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
        <p className="lp-proof-highlight">
          <i className="fa-solid fa-circle-check" aria-hidden="true" /> {highlight}
        </p>
      </div>
      <div className="lp-section-cta">
        <WhatsAppCTA message={ctaMessage} id="cta-proof">
          {cta}
        </WhatsAppCTA>
      </div>
    </div>
  </section>
);

export default SectionProof;
